import {logger} from "./logger";
import type {Event} from "./types";

/**
 * Console handler for development
 * Formats events nicely in the browser console
 */
function consoleHandler(event: Event): void {
  const timestamp = new Date(event.timestamp).toISOString();
  const prefix = `${timestamp} (${event.category}) [${event.severity.toUpperCase()}]`;

  const logFn =
    event.severity === "error"
      ? console.error
      : event.severity === "warn"
        ? console.warn
        : event.severity === "info"
          ? console.info
          : console.debug;

  if (event.context) {
    logFn(prefix, event.message, event.context);
  } else {
    logFn(prefix, event.message);
  }
}

// Register console handler by default
logger.addHandler(consoleHandler);

// Export everything
export {logger} from "./logger";
export type {
  Event,
  EventCategory,
  EventContext,
  EventHandler,
  EventSeverity,
} from "./types";
